import { Row, Col, Typography } from 'antd';
import { AIKpiCard } from './AIKpiCard';

const { Title, Text } = Typography;

export type HomeKpiItem = {
  key: string;
  label: string;
  value: number | string;
  format?: 'number' | 'currency' | 'text';
};

export interface AIExecutiveSummaryCardProps {
  userName?: string;
  kpis: HomeKpiItem[];
  loading?: boolean;
  formatCurrency?: (n: number) => string;
}

function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

export function AIWelcomeCard({ userName }: { userName?: string }) {
  const name = userName?.trim() || 'there';
  return (
    <div style={{ marginBottom: 24 }}>
      <Title level={2} style={{ marginBottom: 4 }}>
        {greeting()}, {name}
      </Title>
      <Text type="secondary" style={{ fontSize: 16 }}>
        Here is your business snapshot.
      </Text>
    </div>
  );
}

export function AIExecutiveSummaryCard({ kpis, loading, formatCurrency }: AIExecutiveSummaryCardProps) {
  return (
    <div style={{ marginBottom: 28 }}>
      <Title level={5} style={{ marginBottom: 12 }}>
        Business snapshot
      </Title>
      <Row gutter={[12, 12]}>
        {kpis.map((k) => (
          <Col xs={24} sm={12} md={8} lg={6} key={k.key}>
            <AIKpiCard
              label={k.label}
              value={k.value}
              format={k.format}
              formatCurrency={formatCurrency}
              loading={loading}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
